// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import UnvisibleSvg from '@rsuite/icon-font/lib/status/Unvisible';
var Unvisible = createSvgIcon({
  as: UnvisibleSvg,
  ariaLabel: 'unvisible',
  category: 'status',
  displayName: 'Unvisible'
});
export default Unvisible;